/**
 * userWeChat模块接口列表
 */
 import $http from '../utils/http'// 导入http中创建的axios实例

 const awsReservationStatistics = {
   // 检查至少有一人绑定过微信
   pageReport(params) {
     return $http.post(`${global.API_URL}/sme/awsReservationStatistics/page`, params)
   },
 };
 
 export default awsReservationStatistics
 


// WEBPACK FOOTER //
// ./src/api/awsReservationStatistics.js